import { useEffect, useRef } from 'react';
import { ArrowUpRight } from 'lucide-react';

export default function GccOffshore() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.1 }
    );
    const els = sectionRef.current?.querySelectorAll('.reveal');
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="gcc-offshore"
      ref={sectionRef}
      data-testid="gcc-offshore-section"
      className="relative py-24 md:py-32 bg-white"
    >
      <div className="absolute top-0 left-0 right-0 h-[2px]" style={{ background: 'linear-gradient(90deg, transparent 10%, #d4af37 50%, transparent 90%)' }} />
      <div className="container mx-auto px-4 md:px-8 max-w-4xl">
        <div className="text-center reveal">
          <p
            className="text-sm uppercase tracking-[0.3em] text-[#1a7a7a] mb-4 font-medium"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Implementation
          </p>
          <h2
            className="text-4xl md:text-5xl font-semibold tracking-tight text-[#1a1a1a] mb-6"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Ready to Put the Strategy Into Action?
          </h2>
          <div className="w-16 h-[1px] bg-[#d4af37] mx-auto mb-8" />
          <p
            className="text-gray-500 text-base leading-relaxed max-w-2xl mx-auto mb-10"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            GCC Offshore is our dedicated portal for establishing offshore companies, trusts,
            foundations, and international banking &mdash; with clear pricing and secure online
            ordering. It is where our strategy becomes structure.
          </p>
          <a
            href="https://www.gcc-offshore.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="gcc-offshore-cta"
            className="inline-flex items-center gap-2 bg-[#1a7a7a] text-white font-bold px-8 py-3.5 rounded-full text-sm hover:bg-[#1a6868] transition-all duration-300"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Explore GCC Offshore
            <ArrowUpRight size={15} strokeWidth={2.5} />
          </a>
        </div>
      </div>
    </section>
  );
}
